import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import OrderedProductsList from '../../modules/ordered-products/OrderedProductsList'

const OrderedProductsPage: React.FC = () => {
  const {formatMessage} = useIntl()
  return (
    <>
      <PageTitle>{formatMessage({id: 'MENU.ORDERED_PRODUCTS'})}</PageTitle>
      <OrderedProductsList />
    </>
  )
}

export default OrderedProductsPage
